import BasicTemplate from './BasicTemplate'

export default BasicTemplate
